import React, { useState } from 'react'
import starIcon from '../../../assets/images/starWhiti.svg'
import filledStarIcon from '../../../assets/images/Filled_Star.svg'
import { useExpandableText } from '../../../hooks/useExpandableText';
import arrowIcon from '../../../assets/images/Tail-arrow.svg'
import useCopyToClipboard from '../../../hooks/useCopyToClipboard';
import { CopyIconSvg } from '../../../components/ui/Svgs';

const buttonData = ["generated", "control", "overlay", "initial"];

const DashboardViewDetails = ({ imageData }) => {

    const [selectedButton, setSelectedButton] = useState(buttonData[0]);
    const [isLoading, setIsLoading] = useState(true);

    const magicPrompt = useExpandableText(imageData.enhancedPrompt, 150);
    const { isCopied: isMagicPromptCopied, copyToClipboard: copyMagicPrompt } = useCopyToClipboard();


    const handleButtonClick = (buttonId) => {
        handleReset()
        setSelectedButton(buttonId);
        setIsLoading(true);
    };

    const getImageByButton = (button) => {
        switch (button) {
            case "overlay":
                return `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.overlayImage}`;
            case "control":
                return `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.controlImage}`;
            case "initial":
                return `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.initImage}`;
            default:
                return imageData?.images?.includes("dump")
                    ? `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`
                    : `${process.env.REACT_APP_AWS_BUCKET_URL}/${imageData?.modelName}/specific_need/${imageData?.md5hash}/${imageData?.images}`;
        }
    };


    const showLoader = () => (
        <div className=" flex items-center justify-center">Loading...</div>
    );

    const starGenerator = (selected) => {
        return Array(5)
            .fill(0)
            .map((_, i) => {
                const isSelected = i < selected;
                return (
                    <img
                        key={i}
                        src={isSelected ? filledStarIcon : starIcon}
                        alt={isSelected ? "Filled Star" : "Empty Star"}
                        style={{
                            marginRight: "10px",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                        }}
                    />
                );
            });
    };

    const [zoom, setZoom] = useState(1); // Initial zoom level
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

    const handleZoomChange = (e) => {
        const newZoom = Number(e.target.value);
        setZoom(newZoom);

        if (newZoom === 1) {
            setPosition({ x: 0, y: 0 });
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartPosition({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPosition({
            x: e.clientX - startPosition.x,
            y: e.clientY - startPosition.y,
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleDragStart = (e) => {
        e.preventDefault();
    };

    const handleReset = () => {
        setZoom(1);
        setPosition({ x: 0, y: 0 });
    };

    return (
        <div className='max-h-[700px] max-w-[1200px] p-[20px]'>
            <div className="sm:flex justify-center gap-[24px] rounded-2xl">
                <div className="flex flex-col gap-3">
                    <div className="grid grid-cols-2 lg:grid-cols-4  gap-2">
                        {buttonData.map((buttonId) => (
                            <button
                                key={buttonId}
                                className={`px-3 py-2 rounded-lg text-sm md:text-base transition-colors duration-500 ${selectedButton === buttonId
                                    ? "bg-[#1A73E8] text-white"
                                    : "bg-[#E7EAEE] hover:bg-[#d7d7d7]"
                                    }`}
                                onClick={() => handleButtonClick(buttonId)}
                            >
                                {buttonId.charAt(0).toUpperCase() + buttonId.slice(1)}
                            </button>
                        ))}
                    </div>

                    {/* <div className="max-w-[600px] min-w-[500px] xl:w-[600px]">
                        {isLoading && (
                            <div className="aspect-[1/1] flex items-center justify-center">
                                {showLoader()}
                            </div>
                        )}
                        <img
                            src={getImageByButton(selectedButton)}
                            className={`aspect-[1/1] rounded-lg ${isLoading ? "hidden" : "block"}`}
                            alt=""
                            onLoad={() => setIsLoading(false)}
                        />
                    </div> */}
                    <div
                        className="relative max-w-[600px] min-w-[500px] xl:w-[600px] overflow-hidden"
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                    >
                        {isLoading && (
                            <div className="aspect-[1/1] flex items-center justify-center">
                                {showLoader()}
                            </div>
                        )}
                        <img
                            src={getImageByButton(selectedButton)}
                            className={`aspect-[1/1] rounded-lg ${isLoading ? "hidden" : "block"}`}
                            alt=""
                            onLoad={() => setIsLoading(false)}
                            style={{
                                transform: `scale(${zoom}) translate(${position.x / zoom}px, ${position.y / zoom}px)`,
                                transformOrigin: "center center",
                                cursor: zoom > 1 ? "grab" : "default",
                            }}
                            onMouseDown={zoom > 1 ? handleMouseDown : null}
                            onDragStart={handleDragStart} // Prevent default drag behavior
                        />
                        {/* Slider Overlay */}
                        <div className="absolute bottom-2 left-0 right-0 p-2  bg-opacity-50 flex justify-center items-center">
                            {/* <button
                                onClick={handleReset}
                                className="px-3 py-1 bg-gray-700 text-white text-sm rounded-md hover:bg-gray-600 transition"
                            >
                                Reset
                            </button> */}
                            <input
                                type="range"
                                min="1"
                                max="3"
                                step="0.1"
                                value={zoom}
                                onChange={handleZoomChange}
                                className="w-[30%] appearance-none h-2 bg-gray-300 rounded-lg"
                            />
                        </div>
                    </div>

                </div>
                <div className="flex flex-col gap-[12px] min-w-[500px] lg:max-w-[500px] xl:max-w-[600px]">
                    <h5 className="h-[32px] text-[28px] font-semibold">
                        Feedback
                    </h5>
                    <div className="w-full flex items-center justify-between">
                        <div className="max-h-[170px]">
                            <span className="small-texts text-secondary font-[400] leading-[16px]">Font Used: </span>
                            <span className="font-bold">{imageData.fontFamily}</span>
                        </div>
                        <a
                            href={
                                imageData?.fontFamilyUrl?.includes("/")
                                    ? `https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}`
                                    : `https://www.myfonts.com/collections/${imageData?.fontFamilyUrl}?utm_source=contextual`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex justify-center items-center gap-[4px] text-blue-dark"
                        >
                            <span className="text-[13px]"> Get this font</span>
                            <img src={arrowIcon} alt="arrowIcon" />
                        </a>
                    </div>
                    <div>
                        <span className="small-texts text-secondary font-[400] leading-[16px]">Time taken: </span>{imageData.imageGenerationTime}
                    </div>
                    <div className="flex flex-col gap-[12px] max-h-[520px] overflow-y-scroll hidden-scrollbar">
                        <div className="flex flex-col gap-[4px]">
                            <div className='flex justify-between'>
                                <span className='small-texts text-secondary font-[400] leading-[16px]'>Magic prompt used</span>
                                <div className='flexCenter gap-[8px]'>
                                    <CopyIconSvg onClick={() => copyMagicPrompt(imageData.enhancedPrompt)} fill={`${isMagicPromptCopied ? '#1A73E8' : '#1E242C'}`} className="cursor-pointer" />
                                    <span className={`${isMagicPromptCopied ? 'text-blue-primary' : ''} text-[13px]`}>{isMagicPromptCopied ? 'Copied' : 'Copy'}</span>
                                </div>
                            </div>

                            <p className='text-cus_primary font-[400] leading-[24px] tracking-[-0.02em]'>
                                {magicPrompt.displayText}<br />
                                {imageData.enhancedPrompt.length > 150 && (
                                    <span onClick={magicPrompt.toggleExpand} className='text-blue-primary cursor-pointer'>
                                        {magicPrompt.isExpanded ? 'Show Less' : 'Know More'}
                                    </span>
                                )}
                            </p>
                        </div>

                        <div className="flex flex-col flex-grow justify-around gap-4 ">
                            <div className="flex flex-col gap-2">
                                <p className="mb-0 font-helvetica-text text-[13px]">
                                    How well did the visualisation inspire you to choose the recommended font?
                                </p>
                                <div className="flex">
                                    {starGenerator(imageData.feedback1)}
                                </div>
                            </div>
                            {/* <div className="flex flex-col gap-2">
                                <p className="mb-0 font-helvetica-text text-[13px]">
                                    How well does the font style align with your project idea?
                                </p>
                                <div className="flex">
                                    {starGenerator(imageData.feedback2)}
                                </div>
                            </div> */}
                            <div className="flex flex-col gap-2">
                                <p className="mb-0 font-helvetica-text text-[13px]">
                                    How would you rate the overall quality of the visualisation?
                                </p>
                                <div className="flex">
                                    {starGenerator(imageData.feedback2)}
                                </div>
                            </div>

                            <div className="flex flex-col gap-2 text-[13px]">
                                <p>What would you improve about this visualisation to better suit your project idea?
                                </p>
                                <p className="font-helvetica-text outline-none w-full min-h-10 px-3 py-2 bg-transparent text-[14px] border  rounded-lg">
                                    {imageData.comment}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardViewDetails